module.exports = __webpack_public_path__ + "static/media/Keepspace Logo big.985a45cf.png";